module.exports = __webpack_public_path__ + "static/media/phone.50590696.svg";